<template>
  <div class="bet-slip-position" :class="{ error: position.error }">
    <div>
      <bet-slip-value class="position-value" :value="position.value" />
      <div class="position-info">
        <div class="position-name ellipsis" :title="position.name">{{ position.name }}</div>
        <div class="position-event-kind ellipsis" v-if="position.event.kind" :title="position.event.kind">{{ position.event.kind }}</div>
        <div class="position-event ellipsis" :title="position.event.name">{{ position.event.name }}</div>
        <div class="position-market ellipsis" :title="position.market">{{ position.market }}</div>
      </div>
    </div>
    <div class="flex position-controls" v-if="position.error && !position.placeable">
      <icon-32 class="remove-button" clickable name="close" @click="remove" />
      <div class="error-message">{{ position.error }}</div>
    </div>
    <div class="flex position-controls" v-else>
      <div class="remove-button" v-if="positions.length > 1" clickable name="close" @click="remove">
        <i-trash-can-outline class="trash-can-outline" />
      </div>
      <div class="option-maximum-button" :class="{ 'not-trash': positions.length <= 1 }" @click="setMaximum">{{ $t('bet-slip.maximum-stake') + ': ' + position.event.maximum + ' ' + currency }}</div>
      <bet-slip-amount
        class="position-amount"
        single
        type="POSITION"
        :target="position.event.id"
        :invalid="position.invalid"
        :amount="this.maximum ? this.maximum : (quickBet.on === true ? quickBet.amount : position.amount)"
        :key="this.maximum"/>
    </div>
    <div class="placeable-error-message error-message" v-if="position.error && position.placeable">{{ position.error }}</div>
  </div>
</template>

<script>
import Icon32 from '@/components/icons/Icon32'
import BetSlipAmount from '@/components/bet-slip/BetSlipAmount'
import BetSlipValue from '@/components/bet-slip/BetSlipValue'
import ITrashCanOutline from 'vue-material-design-icons/TrashCanOutline'
import { mapState } from 'vuex'

export default {
  components: { Icon32, BetSlipAmount, BetSlipValue, ITrashCanOutline },
  computed: {
    ...mapState({
      currency: state => state.user.currency,
      quickBet: state => state.betSlip.quickBet,
      positions: state => state.betSlip.positions
    })
  },
  data () {
    return {
      maximum: null
    }
  },
  props: {
    position: Object
  },
  methods: {
    remove () {
      this.$store.dispatch('betSlip/REMOVE_POSITION', this.position.event.id)
    },
    setMaximum () {
      this.maximum = this.position.event.maximum
    }
  }
}
</script>

<style scoped>
.bet-slip-position { background: #d4dbe3; border-radius: 5px; font-size: 13px; padding: 10px; position: relative; }
.position-value { float: right; margin-bottom: -20px; font-size: 14px; }
.position-info { padding-right: 60px; }
.position-name { color: #713592; font-size: 14px; }
.position-event-kind { color: #342d6e; }
.position-controls { margin-top: 9px; }
.remove-button { margin: 5px 0; cursor: pointer; }
.option-maximum-button { cursor: pointer; height: 40px; line-height: 40px; margin-left: 10px; }
.option-maximum-button:hover { color: #713592; }
.position-amount { display: flex; flex: 1 1; flex-direction: row-reverse; }
.error-message { background: #f44336; border-radius: 2px; padding: 5px 10px; text-align: center; color: white; margin-top: 5px; }
.position-controls .error-message { flex: 1 1; margin-left: 10px; }
.trash-can-outline { color: #342d6e; font-size: 18px; margin-top: 7px; }
.not-trash { margin-left: 0px; }
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipPosition.vue